// 菜单类型
export enum DBIMenuType {
  // 目录
  Directory = '0',
  // 路由页面
  RoutePage = '1',
  // 第三方页面
  ThirdPage = '2',
  // Datalab报表页面
  DatalabReportPage = '3',
  // Tableau类型页面
  TableauPage = '4',
  // COS自定义页面
  COSPage = '5',
  // AuthPath无鉴权报表页面
  AuthPath = '6',
}
